import { render } from "./giftHistoryDialog.vue?vue&type=template&id=a588a8de&scoped=true"
import script from "./giftHistoryDialog.vue?vue&type=script&lang=js"
export * from "./giftHistoryDialog.vue?vue&type=script&lang=js"

import "./giftHistoryDialog.vue?vue&type=style&index=0&id=a588a8de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a588a8de"]])

export default __exports__